import React, { useState } from "react";
import { Upload, X, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, fileUrl } from "@/lib/api";

export function ImageUploader({ images, setImages, max = 5 }) {
  const [uploading, setUploading] = useState(false);

  const onFiles = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    if (images.length + files.length > max) { toast.error(`الحد الأقصى ${max} صور`); return; }
    setUploading(true);
    try {
      for (const file of files) {
        const fd = new FormData();
        fd.append("file", file);
        const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
        setImages((prev) => [...prev, data.path]);
      }
      toast.success("تم رفع الصور");
    } catch { toast.error("فشل رفع الصورة"); }
    finally { setUploading(false); e.target.value = ""; }
  };

  return (
    <div>
      <div className="flex flex-wrap gap-3">
        {images.map((img, i) => (
          <div key={i} className="relative h-20 w-20 rounded-xl overflow-hidden border" style={{ borderColor: "var(--border-c)" }}>
            <img src={fileUrl(img)} alt="" className="h-full w-full object-cover" />
            <button type="button" data-testid={`remove-image-${i}`} onClick={() => setImages(images.filter((_, x) => x !== i))}
              className="absolute top-1 left-1 rounded-full bg-black/70 p-1 text-white"><X size={12} /></button>
          </div>
        ))}
        {images.length < max && (
          <label data-testid="image-upload-label" className="h-20 w-20 rounded-xl border-2 border-dashed flex items-center justify-center cursor-pointer text-[var(--text-muted)] hover:border-[var(--amber)] hover:text-[var(--amber)]" style={{ borderColor: "var(--border-c)" }}>
            {uploading ? <Loader2 size={22} className="animate-spin" /> : <Upload size={22} />}
            <input type="file" accept="image/*" multiple hidden onChange={onFiles} data-testid="image-upload-input" />
          </label>
        )}
      </div>
    </div>
  );
}
